<if(state.active)>
    <span class=`str-timer ${state.urgency ? "urgency" : ""}` aria-label=input.accessibilityText>
        ${state.displayLabel}
    </span>
</if>
<else-if(state.expired)>
    <str-textual-display ...input.expiredText class="str-timer" />
</else-if>
